<template>
  <div class="login">
    <FormLayout
      :title="`LOGIN`"
      :describe="'Register_28'"
    >
      <InputItem
        :label="`E-mail or Mobile`"
        :placeholder="`Enter E-mail or Mobile`"
        v-model="account"
      />
      <InputItem
        :label="`Password`"
        :placeholder="`Enter Password`"
        type="password"
        v-model="password"
        :confirmInput="login"
      />
      <div class="button">
        <Button :disabled="disabled || loading" @click="login">Login</Button>
        <div @click="goRegister" style="left:34px" class="forgot-pwd">Register Now</div>
        <!-- <div @click="goPwdForgot" style="right:34px" class="forgot-pwd">Forgot Password</div> -->

      </div>
    </FormLayout>
  </div>
</template>

<script>
import request from '@/utils/request';
import Button from '../Button';
import FormLayout from '../FormLayout';
import InputItem from '../Input';
import {API_USER_LOGIN} from '@/utils/constant'
import { Common } from "@/utils";
import { CommonMethod } from "@/mixin";

export default {
  mixin:[CommonMethod],
  components: {
    FormLayout,
    InputItem,
    Button,
  },
  data() {
    return {
      // loading
      loading: false,
      // 账号
      account: '',
      // 密码
      password: '',
    };
  },
  methods: {
    goRegister(){
      this.$parent.$parent.toggleLoginModal();
      this.$parent.$parent.showShowRegister();
    },

    goPwdForgot(){
      console.log("//////")

      this.$parent.$parent.toggleLoginModal();
      this.$parent.$parent.showPwdForgot();
    },

    async login() {
      if(this.loading) {return}
      this.loading = true;

      const data = {
        passwd: this.password,
        plat:1
      };
      // 判断是否是邮箱
      const isEmail = /\w[-\w.+]*@([A-Za-z0-9]+\.)+[A-Za-z]{1,30}/.test(this.account);

      // 判断是否是邮箱
      if (isEmail) {
        data.mail = this.account;
      } else {
        data.mobile = this.account;
      }

      try {
        const res = await request(API_USER_LOGIN, {
          method: 'POST',
          data,
        }, false);

        console.log(res)

        // 保存token
        this.$store.commit('globalState/setToken', res.data.token);

        // // 重定向地址
        const redirect = Common.getUrlParams('redirect');
        
        if (redirect) {
          console.log(decodeURIComponent(redirect));
          window.location.href = decodeURIComponent(redirect);
          return;
        }

        // // 隐藏
        this.$parent.$parent.toggleLoginModal();
        // this.$root.eventHub.$emit("platform-setToken", res.data.token);

        // 获取用户信息
        this.$store.dispatch('globalState/getUserInfo');

        // // 获取充值地址
        // this.$store.dispatch('globalState/getChargeAddr');
        // // 获取货币汇率
        // this.$store.dispatch('globalState/getCurrency');
        // // 获取提现配置
        // this.$store.dispatch('globalState/getPaymentCfg');

        // this.$root.eventHub.$emit('set-login-token', res.data.token);
      } catch(error) {

        console.log(error)
        if (error.code) {
          this.$store.commit("globalState/addNotify", {
            // msg: `${error.code} - ${this.$t(`Error_${error.code}`)}`,
            msg: `${error.code} - Please follow the rules`,
            type: "error",
          })
        } else {
          this.$store.commit("globalState/addNotify", {
            msg:  `${error}` +  `Login failed`,
            type: "error",
          })
        }
      }

      this.loading = false;
    },
  },
  computed: {
    // 禁用状态
    disabled() {
      return !this.account || !this.password;
    },
  },
}
</script>

<style lang="less" scoped>
  .login {
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 10px;
  }

  .button {
    margin-top: 15px;
  }

  .forgot-pwd{
    font-weight: bold;
    color: #FC9B65;
    text-decoration:underline;
    cursor: pointer;
    position: absolute;
    bottom: 15px;
  }
</style>
